import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { IDP_GROUP_ROLES_COLUMN_ID } from "../constants";
import IdpGroupRolesListItemDescriptionCell from "./DescriptionCell";
import IdpGroupRolesListItemActionsDropdownCell from "./DropdownActionsCell";
import IdpGroupRolesListItemNameCell from "./NameCell";
import { RoleBinding } from "../types";
import IdpGroupRolesListItemGrantedAtCell from "./GrantedAtCell";

const CELLS = {
  [IDP_GROUP_ROLES_COLUMN_ID.DESCRIPTION]: IdpGroupRolesListItemDescriptionCell,
  [IDP_GROUP_ROLES_COLUMN_ID.NAME]: IdpGroupRolesListItemNameCell,
  [IDP_GROUP_ROLES_COLUMN_ID.DROPDOWN]: IdpGroupRolesListItemActionsDropdownCell,
  [IDP_GROUP_ROLES_COLUMN_ID.GRANTED_AT]: IdpGroupRolesListItemGrantedAtCell,
};

type IdpGroupRolesListItemProps = {
  roleBinding: RoleBinding;
  isLastRole: boolean;
};

const IdpGroupRolesListItem = (props: IdpGroupRolesListItemProps) => {
  const { roleBinding, isLastRole } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as IDP_GROUP_ROLES_COLUMN_ID];
        const uniqueKey = `${id}-${roleBinding.id}`;

        const childrenComponent = <Component roleBinding={roleBinding} isLastRole={isLastRole} />;

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(IdpGroupRolesListItem);
